import { QueryPageBase } from "./../queryPageBase";
//-查询参数
export class QueryForm extends QueryPageBase {
  marketReportTypeId: string = "";
  reportName: string = "";
  beginTime: string = "";
  endTime: string = "";
}
//查询结果数据格式
export class GetByPageData {
  tableData: GetByPageDataDetail[];
  total: number = 0;
}
//-查询结果数据格式-数据部分
export class GetByPageDataDetail {
  reportName: string = "";
  reportFilePath: string = "";
  reportDate: string = "";
  reportPicPath: string = "";
  createUserId: string = "";
  isDeleted: string = "";
  createTime: string = "";
  typeName: string = "";
  ossPath: string = "";
  marketReportTypeId = "";
  id: string = null;
}
// 获取stsToken参数
export class GetStsParam {
  ossType: number = 0; // 上传0 下载1
}
// 上传文件到oss类
export class UploadClass {
  region: string = "oss-cn-beijing";
  accessKeyId: string = "";
  accessKeySecret: string = "";
  bucket: string = process.env.Bucket;
  stsToken: string = "";
}
//-新增一条市场报告-数据部分
export class AddDataDetail {
  reportName: string = "";
  reportFilePath: string = "";
  reportDate: string = "";
  reportPicPath: string = "";
  marketReportTypeId = "";
  id: string = null;
  reUploadFile: boolean = false;
  reUploadPic: boolean = false;
  reportLink: string = "";
}
